<!-- eslint-disable -->
<template lang="pug">
    .battle-create__block
        .battle-create-form
            template(v-if="user.isSuperadmin || user.isManagerOrSupport")
                .battle-create-form__header
                    div {{ $i18n.t('battle.battle_edit_editBattle') }}
                    div
                        cs-button.battle-form__button(
                            size="small",
                            pattern="primary-outline",
                            color="blue",
                            @click="showUsers"
                        )
                            svg-icon.battle-form__button-icon(name="address-book-o", middle)
                            =" "
                            span.battle-form__button-text {{ $i18n.t('olympiads.olympiads_edit_showParticipants') }}
                divider
                battle-form(:id="battleId")
            template(v-else-if="user.type === 'student'")
                .battle-create-form__header
                    div {{ $i18n.t('battle.battle_edit_editTraining') }}
                hr.battle-create-form__divider
                battle-training-form(:id="battleId")
            div(v-else) {{ $i18n.t('common.common_textInfo_pageNotAllowed') }}
</template>

<script>
    /*eslint-disable*/
    import BoxHeader from '../../elements/BoxHeader.vue';
    import BattleForm from './BattleForm.vue';
    import BattleTrainingForm from './trainings/Form.vue';
    import { mapState } from 'vuex';

    export default {
        props: {
            battleId: [Number, String]
        },
        beforeRouteLeave(to, from, next) {
            const allowedPaths = ['battle-level:create', 'battle-training-level:create'];
            if (!allowedPaths.includes(to.name)) {
                this.$store.dispatch('setBattle', null)
            }
            next()
        },
        methods: {
            showUsers () {
                //todo: make logic
                //this.$router.push({name: 'battle:students-list', params: { id: this.battleId }});
            }
        },
        computed: {
            ...mapState({
                user: state => state.auth.user
            })
        },
        data() {
            return  {
                isCreator: true
            }
        },
        components: {
            BoxHeader,
            BattleForm,
            BattleTrainingForm
        }
    }
</script>

<style lang="scss" scoped>
    /*    .content-grid {
            @include make-grid(0);
            .content-grid__col {
                @include make-col(12, 12, 0);
                @include media($lg) {
                    @include make-offset(1, 12);
                    @include make-col(10, 12, 0);
                }
                @include media($xlg) {
                    @include make-offset(2, 12);
                    @include make-col(8, 12, 0);
                }
            }
        }*/

    .battle-create__block {
        background-color: $x-color-white;
        @include media($sm) {
            border-radius: 40px;
            padding: 28px 30px;
        }
    }
    .battle-create-form {
        margin: 0;
        padding: 20px;
        height: 100%;
        background-color: $hsl-color-gray-98;
        box-sizing: border-box;
        border-radius: 20px;
        @include media($md) {
            padding: 30px;
        }
        @include media($lg) {
            padding: 30px 15% 30px 15%;
        }
        display: flex;
        align-items: center;
        flex-direction: column;
    }

    .battle-create-form__header {
        font-weight: 500;
        font-size: 22px;
        line-height: 26px;
    }

    .battle-form__button-icon {
        margin-right: 5px;
    }

    .battle-form {
        &__button {
            margin-top: 20px;
            &-text, &-text {
                vertical-align: middle;
            }
        }
    }
</style>
